import React, { useState, useEffect } from "react"
import CustomTextField from '../../StandardComponents/CustomTextField';
import BasicDatePicker from '../../StandardComponents/BasicDatePicker';
import Collapse from '@material-ui/core/Collapse';

import SimpleTaxMenu from '../../StandardComponents/SimpleTaxMenu';


import { makeStyles } from '@material-ui/core/styles';
import { db } from "../../../firebase"
import { useAuth } from "../../../contexts/AuthContext"

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

import { Typography } from "@material-ui/core";
import GeneralViewContainer from "../../StandardComponents/GeneralViewContainer";
import * as database from '../../../constants/database'


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  snack: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  progressbar: {
    position: 'absolute',
    zIndex : '1000',
    width: '10%',
    height: '100%',
  }

  
}));



function notEmpty(val){
  if(val)
  {
    return true;
  }
  return false;
}

var invoiceTaxTypeBefore = "";
var invoiceTaxTypeLive = "";

var invoiceTaxLabelBefore = "";
var invoiceTaxLabelLive = "";

var invoiceTaxRateBefore = "";
var invoiceTaxRateLive = "";



export default function Settings(props) {



  const { currentUser } = useAuth()

  var userRef = db.collection("users").doc(currentUser.uid);
  var documentsRecordsRef = userRef.collection(database.TABLE_NAME_INVOICES);


  var specificItemRef;

  function setQuery(){

    var docId = localStorage.getItem('doId');
    console.log("WILL NOW SEARCH ID: " +localStorage.getItem('itId'));
    if(!docId)
    {
       props.startSnackBar(true, 20000,"No Contact Provided","error",true)
        return;
    }
    specificItemRef = documentsRecordsRef.doc(docId);
    
  }


  var [loading, setLoading] = useState(false)


  const [invoiceTaxType, setInvoiceTaxType] = useState("")
  const [invoiceTaxLabel, setInvoiceTaxLabel] = useState("")
  const [invoiceTaxRate, setInvoiceTaxRate] = useState("")
  const [showTaxRateAndLabel, setshowTaxRateAndLabel] = useState(false)



  const [open, setOpen] = React.useState(false);
  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };



  async function writeUserData() {
    setLoading(true)
    return specificItemRef.set({
      invoiceTaxType: invoiceTaxType,
      invoiceTaxLabel: invoiceTaxLabel,
      invoiceTaxRate: invoiceTaxRate,
    },{ merge: true })
    .then(() => {
      setLoading(false)
      setError("")

      
      props.setSaveState(false);

      props.startSnackBar(true, 2000,"Saved","success",true)

      invoiceTaxTypeBefore = invoiceTaxTypeLive
      invoiceTaxLabelBefore = invoiceTaxLabelLive
      invoiceTaxRateBefore = invoiceTaxRateLive

  })
  .catch((error) => {
      props.startSnackBar(true, 20000,"Failed to get data. "+error.code,"error",true)

      setLoading(false)
  });
  }





  const fetchData=async()=>{
  return specificItemRef.get().then((doc) => {
    if (doc.exists) {
 
       
          setInvoiceTaxType(doc.data().invoiceTaxType);
          invoiceTaxTypeBefore = doc.data().invoiceTaxType;
          invoiceTaxTypeLive = doc.data().invoiceTaxType;
          handleSelected(doc.data().invoiceTaxType)
        
        if(doc.data().invoiceTaxLabel)
        {
          setInvoiceTaxLabel(doc.data().invoiceTaxLabel);
          invoiceTaxLabelBefore = doc.data().invoiceTaxLabel;
          invoiceTaxLabelLive = doc.data().invoiceTaxLabel;
        }
        if(doc.data().invoiceTaxRate)
        {
          setInvoiceTaxRate(doc.data().invoiceTaxRate);
          invoiceTaxRateBefore = doc.data().invoiceTaxRate;
          invoiceTaxRateLive = doc.data().invoiceTaxRate;
        }
      
      

    } else {
      props.startSnackBar(true, 20000,"No such data","error",true)

    }
}).catch((error) => {
  props.startSnackBar(true, 20000,"Problem getting data. "+error.code,"error",true)

});

}



useEffect(async () => {
  props.handleLoadingState(loading)
}, [loading])


useEffect(async () => {
  
  if(props.activateSave)
  {
    handleSaveData()
  }

}, [props.activateSave])


useEffect(async () => {
  // Update the document title using the browser API
  props.pageDisplayStatus((pageState) => ({...pageState, backButton:true, mainTab:false, invoiceEstimateTab:false, edPrHiTab: false}))

  setLoading(true)
  
try{
  setError("")
  setQuery()
  fetchData();
  props.setSaveState(false);
}
catch(error){
  props.startSnackBar(true, 20000,"Failed to get data. "+error.code,"error",true)
}
  setLoading(false)
}, [])

  function checkForChanges(){

    if((invoiceTaxTypeLive!==invoiceTaxTypeBefore)||
    (invoiceTaxLabelLive!==invoiceTaxLabelBefore)||
    (invoiceTaxRateLive!==invoiceTaxRateBefore))
    {
      props.setSaveState(true);
    }
    else
    {
      props.setSaveState(false);
    }
  }


  const classes = useStyles();

  const [error, setError] = useState("")

  function handleSaveData(){
 
    setQuery()
    writeUserData()
 
  }


function enterKeyDown(val){
  if (val && props.currentSaveState) {
    handleSaveData();
    }
}

  const updateText = (e)=> {

    switch(e.target.id) {
      case "invoiceTaxType":
        setInvoiceTaxType(e.target.value);
        invoiceTaxTypeLive = e.target.value;
      break;
      case "invoiceTaxLabel":
        setInvoiceTaxLabel(e.target.value);
        invoiceTaxLabelLive = e.target.value;
        break;
      case "invoiceTaxRate":
        setInvoiceTaxRate(e.target.value);
        invoiceTaxRateLive = e.target.value;
        break;

    }

    checkForChanges();
  };

  function handleSelected (val) {

    switch(val) {
      case "None":
        setInvoiceTaxType(val);
        setInvoiceTaxLabel("")
        setInvoiceTaxRate("")
        invoiceTaxTypeLive = val;
        setshowTaxRateAndLabel(false)
      break;
      case "On The Total":
        setInvoiceTaxType(val);
        invoiceTaxTypeLive = val;
        setshowTaxRateAndLabel(true)
        break;
      case "Deducted":
        setInvoiceTaxType(val);
        invoiceTaxTypeLive = val;
        setshowTaxRateAndLabel(true)
        break;
      case "Per Item":
        setInvoiceTaxType(val);
        invoiceTaxTypeLive = val;
        setshowTaxRateAndLabel(true)
        break;
      default:
        setInvoiceTaxType("None");
        setInvoiceTaxLabel("")
        setInvoiceTaxRate("")
        setshowTaxRateAndLabel(false)
    }

    checkForChanges();
  };


  return (
    <>

<GeneralViewContainer maxWidth="lg">
      <Grid container spacing={1}>

        <Grid item xs={12}>
        <Typography variant="h5" component="h5">Tax</Typography>
        </Grid>

        <Grid item xs={12}>
        <Box borderTop={1} borderColor="primary.main">
        </Box>
        </Grid>


  <Grid item xs={12}>
      <Tooltip title="Discount">
  {/* <CustomTextField disabled={notEmpty(error)} updateText={updateText}  id="invoiceDiscountType" label="Discount" value={invoiceDiscountType} enterKeyDown={enterKeyDown}/> */}
  <SimpleTaxMenu value={invoiceTaxType} returnSelected={handleSelected}/>

  </Tooltip>
  </Grid>





  <Grid item xs={12}>
  <Collapse in={showTaxRateAndLabel}>
      <Tooltip title="Terms">
  <CustomTextField disabled={notEmpty(error)} updateText={updateText}  id="invoiceTaxLabel" label={"Label"} value={invoiceTaxLabel} enterKeyDown={enterKeyDown}/>
  </Tooltip>
  </Collapse>
  </Grid>


  <Grid item xs={12}>
  <Collapse in={showTaxRateAndLabel}>
      <Tooltip title="Terms">
  <CustomTextField disabled={notEmpty(error)} updateText={updateText}  id="invoiceTaxRate" label={"Rate"} value={invoiceTaxRate} enterKeyDown={enterKeyDown}/>
  </Tooltip>
  </Collapse>
  </Grid>


    </Grid>
    </GeneralViewContainer>

    </>
  )
}
